import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Menu,
  Dialog,
  Avatar,
  Button,
  Divider,
  MenuItem,
  IconButton,
  DialogTitle,
  ListItemIcon,
  DialogActions,
  DialogContent,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { RootState, useAppDispatch } from "../../store";
import { logoutUser } from "../../auth/authSlice";

function getInitials(name = "", secondName = ""): string {
  const firstInitial = name.charAt(0).toUpperCase();
  const secondInitial = secondName.charAt(0).toUpperCase();
  return `${firstInitial}${secondInitial}`;
}

const User = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const user = useSelector((state: RootState) => state.auth.user);
  const menuOpen = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={menuOpen ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? "true" : undefined}
      >
        <Avatar
          sx={{
            width: 40,
            height: 40,
            backgroundColor: "white",
            color: "rgba(0, 129, 199, 1)",
          }}
        >
          {getInitials(user?.first_name, user?.last_name)}
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={menuOpen}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box
          sx={{ p: "8px 16px" }}
        >{`${user?.first_name} ${user?.last_name}`}</Box>
        <Box
          sx={{
            p: "16px",
            pt: "0",
            fontSize: "14px",
            color: "rgba(0, 0, 0, 0.6)",
          }}
        >
          {user?.email}
        </Box>
        <Divider />
        <MenuItem onClick={() => setOpen(true)}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Log out</DialogTitle>
        <DialogContent sx={{ width: "445px" }}>
          Are you sure you want to log out?
        </DialogContent>
        <DialogActions sx={{ pb: 2, pr: 2 }}>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => dispatch(logoutUser(navigate))}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default User;
